import React, { memo, useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
  Select,
  TextField,
  RadioGroup,
  Radio,
  Autocomplete,
  Stack,
  IconButton,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";

import { motion } from "framer-motion";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import configServ from "../../services/config";
import Calculation from "../../utility/Calculations";
import { triggerLoader } from "../../redux/reducers/LoaderTrigger";
import AlertDialog from "../AlertDialog/AlertDialog";
import CardHeadMenu from "../Card/CardHeadMenu/CardHeadMenu";
import Constants from "../../utility/Constants";
import BudgetItem1 from "./BudgetItem1";

//FUNCTION
const BudgetCard1 = ({ editData, setEditData, isChanged, setIsChanged }) => {
  //#region code
  const dispatch = useDispatch();
  //const navigate = useNavigate();
  const { user_id, company_id, is_super, is_admin, permissions } = useSelector(
    (state) => state.GlobalVariables
  );

  const [customers, setCustomers] = useState([]);
  const budgetItemInitial = [
    {
      id: 1,
      account: "",
      product: "",
      costmaster: "",
      location: "",
      currency: "",
      amount: "",
    },
  ];
  const [budgetItemList, setBudgetItemList] = useState(budgetItemInitial);
  const [customerListError, setCustomerListError] = useState([]);
  const formDataInitial = {
    generate_voucher_no: true,
    project: null,
    budget_code: "",
    budget_date: Calculation.GetCurrentDate(),
    remarks: null,
    status: true,
    send_mail: false,
  };
  const [formData, setFormData] = useState(formDataInitial);
  const [validationErrors, setValidationErrors] = useState({});
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [title, setTitle] = useState("Alert");
  const [dialogContent, setDialogContent] = useState("");
  const [buttonType, setButtonType] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [voucherDetails, setVoucherDetails] = useState([]);
  const [editVoucherDetails, setEditVoucherDetails] = useState(null);
  const [error, setError] = useState(false);
  const [reset, setReset] = useState(false);
  const [loading, setLoading] = useState(false);
  const [projectMasterList, setProjectMasterList] = useState([]);

  const handleOpenDialog = (heading, content, type) => {
    setTitle(heading);
    setDialogContent(content);
    setButtonType(type);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setTitle("Alert");
    setDialogContent("");
    setButtonType(null);
  };

  // useEffect(() => {
  //     fetchCustomerList();
  // }, []);

  useEffect(() => {
    setReset(!reset);
  }, [formData.entity_type]);

  useEffect(() => {
    calculateTotalAmount();
  }, [budgetItemList]);

  useEffect(() => {
    if (Object.keys(editData).length !== 0) {
      const data = {
        id: editData.id,
        generate_voucher_no: true,
        project: editData.project,
        budget_code: editData.budget_code,
        budget_date: editData.budget_date,
        total_amount: editData.total_amount,
        remarks: editData.remarks,
        status: Boolean(editData.status),
        send_mail: false,
      };
      setTotalAmount(editData.total_amount);
      setFormData(data);
      const items = editData.budget_items.map((item) => ({
        id: item.id,
        account: item.account,
        product: item.product,
        costmaster: item.costmaster,
        location: item.location,
        currency: item.currency,
        amount: item.amount,
        document: item.document,
        fileType: item.document ? "application/pdf" : "",
      }));
      setBudgetItemList(items);
      setEditVoucherDetails(items);
      setIsEdit(true);
      setIsCreate(true);
    }
  }, [editData]);

  const fetchProjectMaster = async () => {
    try {
      const res = await configServ.getAllProjectMasters({
        company_id: company_id,
      });
      if (res.status === 200) {
        const result = res.data.filter((x) => x.status === 1);
        setProjectMasterList(res.data || []);
      } else {
        setProjectMasterList([]);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchProjectMaster();
  }, []);

  const handlePopup = () => {
    try {
      if (isCreate === true) {
        handleReset();
      }
      setIsCreate(!isCreate);
    } catch (e) {
      console.log(e);
    }
  };

  const handleFormData = (event) => {
    try {
      const { name, value } = event.target;

      //Update form
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      // Reset the validation error when the user starts typing
      if (validationErrors[name]) {
        setValidationErrors((prevValidationError) => ({
          ...prevValidationError,
          [name]: "",
        }));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleIsCreditChange = (params) => {
    try {
      const { name, value } = params.target;
      var isCredit = true;
      if (value === "false") {
        isCredit = false;
      }
      setFormData((prev) => ({
        ...prev,
        [name]: isCredit,
      }));
    } catch (e) {
      console.log(e);
    }
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormData((state) => ({
      ...state,
      [name]: checked,
    }));
  };

  const fetchInvoiceByCustomerID = async (customer_id) => {
    try {
      const dataToSend = {
        customer_id: customer_id,
      };
      const res = await configServ.getInvoiceByCustomerID(dataToSend);
      if (res.status === 200) {
        return res.data;
      } else {
        return null;
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleAutocompleteChange = (event, id) => {
    const value = event.target.innerText;
    if (value !== null && value !== undefined) {
      if (value.length > 0) {
        handleInputChange({ target: { name: "fname", value } }, id);
      }
    }
  };

  const handleInvoiceChange = (value, id) => {
    if (value !== null && value !== undefined) {
      if (value) {
        handleInputChange({ target: { name: "invoice_number", value } }, id);
      }
    }
  };

  const handleInputChange = async (event, id) => {
    try {
      const { name, value } = event.target;
      let updatedCustomer = [];
      // if (value !== null && value !== undefined) {
      //     if (value.length > 0) {
      //         if (name === "fname") {
      //             // Find the selected item from the options
      //             const valueData = value.split("~")[0];
      //             const selectedItem = customers.find(
      //                 (item) => item.fname.toLowerCase() === valueData.toLowerCase()
      //             );
      //             // If a valid item is selected, update the item properties accordingly
      //             if (selectedItem) {
      //                 const invoiceList = await fetchInvoiceByCustomerID(
      //                     selectedItem.id
      //                 );
      //                 updatedCustomer = {
      //                     ...budgetItemList.find((item) => item.id === id),
      //                     customer_id: selectedItem.id,
      //                     fname: selectedItem.fname,
      //                     address: selectedItem.address,
      //                     invoiceList: invoiceList,
      //                 };
      //             } else {
      //                 // If the selected item is not found, reset the properties
      //                 updatedCustomer = {
      //                     ...budgetItemList.find((item) => item.id === id),
      //                     customer_id: "",
      //                     fname: "",
      //                     address: "",
      //                 };
      //             }
      //         } else if (name === "invoice_number") {
      //             // Find the selected invoice item
      //             const selectedInvoice = budgetItemList
      //                 .find((item) => item.id === id)
      //                 .invoiceList.find((item) => item.invoice_number === value);
      //             // For other fields, just update the value
      //             updatedCustomer = {
      //                 ...budgetItemList.find((item) => item.id === id),
      //                 [name]: value,
      //                 inv_id: selectedInvoice ? selectedInvoice.id : "",
      //                 invoice_amount: selectedInvoice
      //                     ? selectedInvoice.total_amount
      //                     : "",
      //             };
      //         } else {
      //             // For other fields, just update the value
      //             updatedCustomer = {
      //                 ...budgetItemList.find((item) => item.id === id),
      //                 [name]: value,
      //             };
      //         }
      //         // Update the budgetItemList state with the updated item
      //         const updatedCustomerList = budgetItemList.map((item) =>
      //             item.id === id ? updatedCustomer : item
      //         );
      //         setBudgetItemList(updatedCustomerList);
      //     } else {
      //         // For other fields, just update the value
      //         updatedCustomer = {
      //             ...budgetItemList.find((item) => item.id === id),
      //             [name]: value,
      //         };
      //     }
      //     // Update the budgetItemList state with the updated item
      //     const updatedCustomerList = budgetItemList.map((item) =>
      //         item.id === id ? updatedCustomer : item
      //     );
      //     setBudgetItemList(updatedCustomerList);
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const calculateTotalAmount = () => {
    let totalAmount = 0;
    budgetItemList.forEach((item) => {
      // Parse the total_amount string to a float value
      const total_amount = parseFloat(item.amount);
      // Check if the total_amount is a valid number
      if (!isNaN(total_amount)) {
        // Add the total_amount to the total
        totalAmount += total_amount;
      }
    });
    setTotalAmount(totalAmount.toFixed(2));
  };

  // Function to add a new customer to the list
  const handleAddCustomer = () => {
    setBudgetItemList([...budgetItemList, { id: budgetItemList.length + 1 }]);
  };

  // Function to delete an item from the list based on its ID
  const handleDeleteCustomer = (id) => {
    const updatedCustomerList = budgetItemList.filter((item) => item.id !== id);
    setBudgetItemList(updatedCustomerList);
  };

  const validate = async () => {
    try {
      const errors = {};
      if (formData.generate_voucher_no === false) {
        if (!formData.budget_code) {
          errors.budget_code = "Voucher No is required.";
        }
      }
      if (!formData.project) {
        errors.project = "Account is required.";
      }
      if (!formData.budget_date) {
        errors.budget_date = "Date is required.";
      }
      setValidationErrors(errors);

      return Object.values(errors).every((error) => error === "");
    } catch (e) {
      console.log(e);
    }
  };

  // const validateCustomerList = async () => {
  //     const errors = budgetItemList.map((item) => ({
  //         customer_id: !item.customer_id ? "Customer Name is required." : "",
  //         amount: !item.amount ? "Amount is required." : "",
  //         // Add additional validations for other item fields as needed...
  //     }));

  //     setCustomerListError(errors);
  //     // Check if there are any errors
  //     const hasErrors = errors.some((error) =>
  //         Object.values(error).some((val) => val !== "")
  //     );

  //     return !hasErrors;
  // };

  const handleBudgetItem = async () => {
    try {
      const payRecpCustomers = voucherDetails.map((item) => ({
        account: item.account,
        product: item.product,
        costmaster: item.costmaster,
        location: item.location,
        currency: item.currency,
        amount: item.amount,
        document: item.image,
      }));
      return payRecpCustomers;
    } catch (e) {
      console.log(e);
    }
  };

  const handleSubmit = async (event) => {
    try {
      setLoading(true);
      dispatch(triggerLoader());
      event.preventDefault();

      const validateCard = await validate();
      if (validateCard === false || error === true) {
        return false;
      }
      formData.total_amount = totalAmount;
      formData.company_id = company_id;
      formData.user_id = user_id;
      formData.items = await handleBudgetItem();
      if (!isEdit) {
        const res = await configServ.createBudget(formData);
        if (res.status === 200) {
          setIsChanged(!isChanged);
          handleOpenDialog(
            "Success",
            res.message || "Budget created successfully.",
            "success"
          );
          handleReset();
        } else if (res.status === 400) {
          handleOpenDialog(
            "Warning",
            res.message || "Failed to create budget.",
            "warning"
          );
        } else {
          handleOpenDialog(
            "Error",
            res.message || "Failed to create budget.",
            "error"
          );
        }
      } else {
        const res = await configServ.updateBudget(formData);
        if (res.status === 200) {
          setIsChanged(!isChanged);
          handleOpenDialog(
            "Success",
            res.message || "Budget updated successfully.",
            "success"
          );
          handleReset();
        } else {
          handleOpenDialog(
            "Error",
            res.message || "Failed to update budget.",
            "error"
          );
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
      dispatch(triggerLoader());
    }
  };

  const handleReset = () => {
    try {
      setFormData(formDataInitial);
      setValidationErrors({});
      setBudgetItemList(budgetItemInitial);
      setCustomerListError({});
      setEditData({});
      setIsEdit(false);
      setReset(!reset);
      setVoucherDetails([]);
      setEditVoucherDetails(null);
    } catch (e) {
      console.log(e);
    }
  };

  const handleVoucherDetail = (params) => {
    try {
      setVoucherDetails(params);
      // Calculate the total amount using reduce
      const totalAmount = params.reduce((acc, item) => {
        return acc + Number(item.amount);
      }, 0);
      setTotalAmount(totalAmount);
    } catch (e) {
      console.log(e);
    }
  };

  const handleCut = () => {
    setIsCreate(!isCreate);
    handleReset();
  };
  //#endregion

  return (
    <>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseDialog}
        title={title}
        message={dialogContent}
        buttonTitle="Ok"
        buttonType={buttonType}
      />

      <CardHeadMenu
        prefix={"Inv"}
        suffix={"Order"}
        title={"BUDGET"}
        handlePopup={handlePopup}
        isEdit={isEdit}
        create={isCreate}
        showCreate={Boolean(is_super || is_admin || permissions?.includes(31))}
      />

      {isCreate === true && (
        <>
          <motion.div
            style={{
              width: "100%",
              backgroundColor: "#e3f3fc",
              padding: 20,
              borderRadius: "10px",
              border: "none",
            }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1, delay: 0.1 }}
          >
            <form onSubmit={handleSubmit} onReset={handleReset}>
              <Grid
                container
                alignItems="flex-end"
                justifyContent="flex-start"
                sx={{ p: 0 }}
                spacing={1}
              >
                <Grid item xs={6} md={6} p={0}>
                  <FormControlLabel
                    control={<Checkbox />}
                    checked={Boolean(formData.generate_voucher_no)}
                    name="generate_voucher_no"
                    onChange={handleChangeCheckbox}
                    label="Auto Generate"
                    sx={{ fontWeight: "bold", m: 0, p: 0 }}
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={6}
                  md={6}
                  alignItems={"center"}
                  justifyContent={"flex-end"}
                >
                  <Stack direction={"row"} spacing={1}>
                    {isEdit ? (
                      <>
                        {" "}
                        <IconButton
                          onClick={handleCut}
                          sx={{
                            borderRadius: 2, // Rounded corners
                            px: 2, // Horizontal padding
                            py: 1, // Vertical padding
                            backgroundColor: "red", // Base red background
                            color: "white", // Icon color
                            "&:hover": {
                              backgroundColor: "darkred", // Darker red on hover for better contrast
                            },
                            boxShadow: 2, // Add a subtle shadow for depth
                            ml: 1, // Margin left to separate from other elements
                            transition: "all 0.3s ease", // Smooth transition for hover effect
                          }}
                          title="close"
                        >
                          <CancelIcon sx={{ fontSize: 18 }} />{" "}
                          {/* Slightly larger icon for better visibility */}
                        </IconButton>
                      </>
                    ) : (
                      <>
                        {" "}
                        <IconButton
                          onClick={handleReset}
                          sx={{
                            borderRadius: 2,
                            px: 2, // Horizontal padding
                            py: 1, // Vertical padding
                            backgroundColor: "secondary.main", // Use theme secondary color
                            color: "white", // Icon color
                            "&:hover": {
                              backgroundColor: "secondary.dark", // Darker shade on hover
                            },
                            ml: 1, // Margin left to separate from other elements
                          }}
                          title="Reset"
                        >
                          <RotateLeftIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </>
                    )}

                    <IconButton
                      size="small"
                      onClick={handleSubmit}
                      sx={{
                        borderRadius: 2,
                        px: 2, // Horizontal padding
                        py: 1, // Vertical padding
                        backgroundColor: isEdit
                          ? "success.main"
                          : "primary.main", // Use theme primary color
                        color: "white", // Icon color
                        "&:hover": {
                          backgroundColor: isEdit
                            ? "success.dark"
                            : "primary.dark", // Darker shade on hover
                        },
                      }}
                      title={isEdit ? "Update" : "Save"}
                    >
                      {isEdit ? (
                        <UpdateIcon sx={{ fontSize: 16 }} />
                      ) : (
                        <SaveIcon sx={{ fontSize: 16 }} />
                      )}
                    </IconButton>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    disabled={isEdit || formData.generate_voucher_no}
                    fullWidth
                    size="small"
                    sx={{ backgroundColor: "white" }}
                    label={"Budget Code"}
                    name="budget_code"
                    value={formData.budget_code || ""}
                    onChange={handleFormData}
                    error={!!validationErrors.budget_code}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Budget Date"
                    type="date"
                    fullWidth
                    size="small"
                    name="budget_date"
                    value={formData.budget_date || ""}
                    onChange={handleFormData}
                    sx={{ backgroundColor: "white" }}
                    InputLabelProps={{ shrink: true }}
                    error={!!validationErrors.budget_date}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel error={!!validationErrors.project}>
                      Project
                    </InputLabel>
                    <Select
                      fullWidth
                      size={"small"}
                      label="Project"
                      id="project"
                      name="project"
                      value={formData.project || ""}
                      onChange={handleFormData}
                      sx={{ backgroundColor: "white" }}
                      error={!!validationErrors.project}
                    >
                      {projectMasterList.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="Remarks"
                    type="text"
                    fullWidth
                    size="small"
                    name="remarks"
                    value={formData.remarks || ""}
                    onChange={handleFormData}
                    sx={{ backgroundColor: "white" }}
                    multiline
                    rows={2}
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  md={12}
                  justifyContent={"flex-end"}
                >
                  <FormControlLabel
                    control={<Checkbox />}
                    name="status"
                    checked={Boolean(formData.status)}
                    onChange={handleChangeCheckbox}
                    label="Status"
                    sx={{ fontWeight: "bold" }}
                  />
                  {/* <FormControlLabel
                                        control={<Checkbox />}
                                        name="send_mail"
                                        checked={Boolean(formData.send_mail)}
                                        onChange={handleChangeCheckbox}
                                        label="Send Mail"
                                        sx={{ fontWeight: "bold" }}
                                    /> */}
                </Grid>
              </Grid>

              <motion.div
                style={{
                  width: "100%",
                  backgroundColor: "#eeeef0",
                  paddingTop: 0,
                  paddingBottom: 0,
                  borderRadius: "10px",
                  border: "none",
                  margin: "20px 0px",
                }}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, delay: 0.1 }}
              >
                <BudgetItem1
                  voucherDetails={handleVoucherDetail}
                  editVoucherDetails={editVoucherDetails}
                  setError={setError}
                  reset={reset}
                />
              </motion.div>
              <Grid container alignItems={"center"} spacing={2}>
                <Grid
                  item
                  xs={12}
                  md={8}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="body1" color={"green"}>
                    Net Amount: ₹{totalAmount}
                  </Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  md={4}
                  alignItems={"center"}
                  justifyContent={"flex-end"}
                >
                  <Stack direction={"row"}>
                    <IconButton
                      size="small"
                      onClick={handleSubmit}
                      sx={{
                        borderRadius: 2,
                        px: 2, // Horizontal padding
                        py: 1, // Vertical padding
                        backgroundColor: isEdit
                          ? "success.main"
                          : "primary.main", // Use theme primary color
                        color: "white", // Icon color
                        "&:hover": {
                          backgroundColor: isEdit
                            ? "success.dark"
                            : "primary.dark", // Darker shade on hover
                        },
                      }}
                      title={isEdit ? "Update" : "Save"}
                    >
                      {isEdit ? (
                        <UpdateIcon sx={{ fontSize: 22 }} />
                      ) : (
                        <SaveIcon sx={{ fontSize: 22 }} />
                      )}
                    </IconButton>
                  </Stack>
                </Grid>
              </Grid>
            </form>
          </motion.div>
        </>
      )}
    </>
  );
};

export default memo(BudgetCard1);
